export enum FailureReasons {
  PRODUCT_API_FAILURE = 'PRODUCT_API_FAILURE',
  SMART_LINK_RESOLVE_FAILURE = 'SMART_LINK_RESOLVE_FAILURE',
  AI_CLUSTERING_API_FAILURE = 'AI_CLUSTERING_API_FAILURE',
  TEST_TIMEOUT = 'TEST_TIMEOUT',
}

export interface FailureSummary {
  /**
   * The source of the failure. Typically an external API which we depend upon.
   */
  source: FailureReasons;
  /**
   * The API client were the error was encountered.
   */
  location: string;
  /**
   * The API endpoint which was being communicated with.
   */
  endpoint: string;
}
